module.exports = __webpack_public_path__ + "media/step_5_en.9e119dc4.mp3";